module.exports = __webpack_public_path__ + "img/Fuchsreiterin.e72a3b29.svg";